'use client';

import styled, { TColorProp } from 'styled-components';

import { getThemeColor } from '~/common/utils/get-theme-color';

export type TParagraphSize =
  | 'x-large'
  | 'large'
  | 'medium'
  | 'small'
  | 'x-small';

interface IContainerProps {
  $size: TParagraphSize;
  $color: TColorProp;
}

export const getParagraphLineHeight = {
  'x-large': 32,
  large: 24,
  medium: 24,
  small: 20,
  'x-small': 16,
} as Record<TParagraphSize, number>;

export const getParagraphFontSize = {
  'x-large': 24,
  large: 18,
  medium: 16,
  small: 14,
  'x-small': 12,
} as Record<TParagraphSize, number>;

export const getParagraphLetterSpacing = (size: TParagraphSize): number => {
  const fontSize = getParagraphFontSize[size];
  const percentage = (
    {
      'x-large': -1.5,
      large: -1.5,
      medium: -1.1,
      small: -0.6,
      'x-small': 0,
    } as Record<TParagraphSize, number>
  )[size];

  return (fontSize * percentage) / 100;
};

export const Container = styled.p<IContainerProps>`
  line-height: ${({ $size }) => getParagraphLineHeight[$size]}px;
  font-size: ${({ $size }) => getParagraphFontSize[$size]}px;
  letter-spacing: ${({ $size }) => getParagraphLetterSpacing($size)}px;
  font-weight: 400;
  color: ${({ theme, $color }) => getThemeColor(theme, $color)};
`;
